<template>
  <div class="universal-model">
    <div class="model_hide">
      <div class="model-top">
      <img 
      :src="contentData.contentImage" alt="">
      <div class="box-title">{{ contentData.title }}</div>
    </div>
    <div class="box-text">{{ contentData.text }}</div>
    </div>
    <div class="model_show">
      <div class="model-top2">
      <img :src="contentData.contentImage" alt="" />
      <div class="box-title">{{ contentData.title }}</div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'superiorityContent',
  components: {},
  props: {
    'contentData': {
      type: Object,
      default: {},
    },
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>